// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"ea96360a","185":"5cc947ed","374":"8f87c0cb","462":"60674aca","495":"6ece893b","537":"497a02bf","572":"9ea6b39a","630":"641d2ff8","640":"4343b197","726":"34432bcc","741":"3b78f8c9","787":"2489fe92","937":"2f86b509"}[chunkId] + ".chunk.js";
};